import React, { memo } from "react";

import { ListTextWrapper } from "./styles";

interface IThingsToRememberProps {
    thingsToRemember: string[];
}

const ThingsToRemember = ({ thingsToRemember }: IThingsToRememberProps) => {
    return (
        <ListTextWrapper variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
            <ol>
                {thingsToRemember.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ol>
        </ListTextWrapper>
    );
};

export default memo(ThingsToRemember);
